<script>
  import "../node_modules/chota/dist/chota.min.css";
  import converter from "./converter";
  let text = "";
  let result = "";
  let textInput;
  let textOutput;

  const convert = () => {
    result = converter.convert(text);
  };
  const copy = () => {
    if (result === "") {
      alert("変換結果が出力されていません。");
      return;
    }
    navigator.clipboard.writeText(result).then((e) => {
      alert("コピーしました。");
    });
  };
  const tweet = () => {
    if (result === "") {
      alert("変換結果が出力されていません。");
      return;
    }
    const encoded = encodeURIComponent(result);
    console.log(encoded);
    const url = `https://twitter.com/intent/tweet?text=${encoded}`;
    window.open(url, "_blank");
  };
</script>

<main>
  <div class="container">
    <h1>縦書き変換ツール</h1>
    <p class="description">
      横書きのテキストを縦書きに変換します。<br />
      ハッシュ(#)から始まる行、URL(http://～,https://～)から始まる行は縦書きにならずに末尾に出力されます。
    </p>
    <textarea
      bind:value={text}
      bind:this={textInput}
      on:focus={textInput.select()}
      class="input"
      placeholder="変換したい文字列"
    />
    <button class="button convert" on:click={convert}>変換</button>
    <textarea
      bind:value={result}
      bind:this={textOutput}
      on:focus={textOutput.select()}
      class="output"
      placeholder="変換後の文字列"
      readonly
    />
    <div class="controller">
      <button class="button copy" on:click={copy}>コピー</button>
      <button class="button tweet" on:click={tweet}>ツイート</button>
    </div>
  </div>
  <hr />
  <footer class="copyright">
    © 2021
    <a
      href="https://twitter.com/de_teiu_tkg"
      target="_blank"
      rel="noopener noreferrer"
    >
      @de_teiu_tkg
    </a>
  </footer>
</main>

<style>
  body {
    width: 100%;
    height: 100%;
  }
  h1 {
    text-align: center;
  }
  main {
    font-family: monospace;
    width: 100%;
    height: 100%;
    background-color: aliceblue;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 640px;
  }
  textarea {
    resize: none;
  }
  .input {
    height: 100px;
  }
  .output {
    height: 200px;
  }
  .controller {
    display: flex;
    width: 100%;
  }
  .controller > button {
    flex-grow: 1;
  }
  .convert {
    background-color: #00d1b2;
    color: white;
  }
  .copy {
    background-color: #ff9970;
    color: white;
  }
  .tweet {
    background-color: #1b95e0;
    color: white;
  }
  .copyright {
    text-align: center;
  }
</style>
